class ProductGrid extends HTMLElement {
  constructor() {
    super();

    this.nextCollection = this.getAttribute('data-next-collection');
    this.currentCollectionUrl = this.getAttribute('data-current-collection');

    this.ajaxContainer = '#product-grid';
    this.ajaxPagination = '#product-grid__pagination';

    console.log(this.ajaxContainer);

    // Initiate Infinite Scroll
    const endlessScroll = new Ajaxinate({
      container: this.ajaxContainer,
      pagination: this.ajaxPagination,
      offset: 1500,
      url: this.currentCollectionUrl
    });

    document.addEventListener('infinite-scroll:end', (event) => {
      this.loadNextCategory(this.nextCollection);
    })

    // Select the element you want to observe
    const targetElement = this.querySelector('#load-next-category'); // Replace with your element selector

    // Create the intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadNextCategory(this.nextCollection);
          observer.unobserve(targetElement);
        }
      });
    }, { threshold: 0.001 }); // You can adjust the threshold to control how much of the element needs to be visible

    // Start observing the target element
    observer.observe(targetElement);
  }

  loadNextCategory(nextCollection) {
    if (nextCollection != "") {
      fetch(nextCollection)
        .then(response => response.text())
        .then(data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          const newItems = doc.querySelector('product-grid'); // Adjust the selector based on your theme

          this.after(newItems);
        })
        .catch(error => {
          console.error('Error loading new collection:', error);
        });
    }
  }
}

customElements.define('product-grid', ProductGrid);
